export const licitaciones2025 = [
  {
    titulo: "CONVOCATORIA 01-2025",
    subtitulo: [
      {
        informacionTitulo: "EA-913005999-N1-2025",
      },
      {
        informacionTitulo: "EA-913005999-N2-2025",
      },
    ],
  },
  {
    titulo: "CONVOCATORIA 01-2025 OBRA",
    subtitulo: [
      {
        informacionTitulo: "CAASIM-HGO-L.O.P.-01-2025",
      },
    ],
  },
  {
    titulo: "CONVOCATORIA 02-2025",
    subtitulo: [
      {
        informacionTitulo: "EA-913005999-N3-2025",
      },
      {
        informacionTitulo: "EA-913005999-N4-2025",
      },
      {
        informacionTitulo: "EA-913005999-N5-2025",
      },
      {
        informacionTitulo: "EA-913005999-N6-2025",
      },
      {
        informacionTitulo: "EA-913005999-N7-2025",
      },
    ],
  },
  {
    titulo: "CONVOCATORIA 03-2025",
    subtitulo: [
      {
        informacionTitulo: "EA-913005999-N8-2025",
      },
      {
        informacionTitulo: "EA-913005999-N9-2025",
      },
    ],
  },
  {
    titulo: "CONVOCATORIA 04-2025",
    subtitulo: [
      {
        informacionTitulo: "EA-913005999-N10-2025",
      },
    ],
  },
  {
    titulo: "CONVOCATORIA 05-2025",
    subtitulo: [
      {
        informacionTitulo: "EA-913005999-N11-2025",
      },
      {
        informacionTitulo: "EA-913005999-N12-2025",
      },
      {
        informacionTitulo: "EA-913005999-N13-2025",
      },
      {
        informacionTitulo: "EA-913005999-N14-2025",
      },
    ],
  },
  {
    titulo: "CONVOCATORIA 02-2025 OBRA",
    subtitulo: [
      {
        informacionTitulo: "CAASIM-HGO-L.O.P.-02-2025",
      },
    ],
  },
  {
    titulo: "CONVOCATORIA 03-2025 OBRA",
    subtitulo: [
      {
        informacionTitulo: "CAASIM-HGO-L.O.P.-03-2025",
      },
    ],
  },
  {
    titulo: "CONVOCATORIA 06-2025",
    subtitulo: [
      {
        informacionTitulo: "EA-913005999-N15-2025",
      },
      {
        informacionTitulo: "EA-913005999-N16-2025",
      },
      {
        informacionTitulo: "EA-913005999-N17-2025",
      },
      {
        informacionTitulo: "EA-913005999-N18-2025",
      },
    ],
  },
  {
    titulo: "CONVOCATORIA 04-2025 OBRA",
    subtitulo: [
      {
        informacionTitulo: "CAASIM-HGO-L.O.P.-04-2025",
      },
    ],
  },
  {
    titulo: "CONVOCATORIA 07-2025",
    subtitulo: [
      {
        informacionTitulo: "EA-913005999-N19-2025",
      },
      {
        informacionTitulo: "EA-913005999-N20-2025",
      },
      {
        informacionTitulo: "EA-913005999-N21-2025",
      },
    ],
  },
  {
    titulo: "CONVOCATORIA 08-2025",
    subtitulo: [
      {
        informacionTitulo: "EA-913005999-N22-2025",
      },
      {
        informacionTitulo: "EA-913005999-N23-2025",
      },
      {
        informacionTitulo: "EA-913005999-N24-2025",
      },
    ],
  },
  {
    titulo: "CONVOCATORIA MULTIPLE 05-2025",
    subtitulo: [
      {
        informacionTitulo: "CAASIM-HGO-L.O.P.-05-2025",
      },
      {
        informacionTitulo: "CAASIM-HGO-L.O.P.-06-2025",
      },
    ],
  },
  {
    titulo: "CONVOCATORIA 09-2025",
    subtitulo: [
      {
        informacionTitulo: "EA-913005999-N25-2025",
      },
    ],
  },
  {
    titulo: "CONVOCATORIA 10-2025",
    subtitulo: [
      {
        informacionTitulo: "EA-913005999-N26-2025",
      },
    ],
  },
  {
    titulo: "CONVOCATORIA 11-2025",
    subtitulo: [
      {
        informacionTitulo: "EA-913005999-N27-2025",
      },
      {
        informacionTitulo: "EA-913005999-N28-2025",
      },
      {
        informacionTitulo: "EA-913005999-N29-2025",
      },
    ],
  },
  {
    titulo: "CONVOCATORIA 12-2025",
    subtitulo: [
      {
        informacionTitulo: "EA-913005999-N30-2025",
      },
      {
        informacionTitulo: "EA-913005999-N31-2025",
      },
    ],
  },
    {
    titulo: "CONVOCATORIA 13-2025",
    subtitulo: [
      {
        informacionTitulo: "EA-913005999-N32-2025",
      },
      {
        informacionTitulo: "EA-913005999-N33-2025",
      },
      {
        informacionTitulo: "EA-913005999-N34-2025",
      },
      {
        informacionTitulo: "EA-913005999-N35-2025",
      },
    ],
  },
];
